/** 애플리케이션 디자인 토큰의 단일 원본입니다. */
const palette = {
  navy900:'#1E3A8A',blue700:'#1D4ED8',blue600:'#2563EB',blue500:'#3B82F6',
  blue400:'#60A5FA',blue300:'#93C5FD',blue200:'#BFDBFE',blue100:'#DBEAFE',blue50:'#EFF6FF',
  slate900:'#20242B',slate800:'#27313C',slate700:'#334155',slate600:'#46515D',
  slate500:'#66727F',slate400:'#8A949F',slate300:'#A2AAB2',gray300:'#DFE5EB',
  gray200:'#E5E8EB',gray100:'#EDF0F3',gray50:'#F8FAFC',white:'#FFFFFF',
  green600:'#059669',red600:'#D14343',red500:'#EF4444',
};

export const fontSizes = {
  8:'8px',9:'9px',10:'10px',11:'11px',12:'12px',12_5:'12.5px',13:'13px',13_5:'13.5px',
  14:'14px',14_5:'14.5px',15:'15px',16:'16px',17:'17px',18:'18px',19:'19px',20:'20px',
  21:'21px',22:'22px',24:'24px',26:'26px',27:'27px',display:'152px',
};

export const light = {
  palette,
  color: {
    mainColor:palette.navy900,mainColorOpacity20:`${palette.navy900}33`,mainColorOpacity5:`${palette.navy900}0d`,
    subColor:palette.blue500,subColorOpacity20:`${palette.blue500}33`,subColorOpacity5:`${palette.blue500}0d`,
    primary:palette.blue500,primaryStrong:palette.blue600,primaryDark:palette.blue700,
    primarySoft:palette.blue50,primaryMuted:palette.blue100,primaryBorder:palette.blue200,primaryFocus:palette.blue300,
    bgColor:palette.gray50,surface:palette.white,surfaceMuted:'#F8FBFF',textColor:'#222222',
    textStrong:palette.slate800,text:palette.slate600,textMuted:palette.slate400,reverseTextColor:'#AAAAAA',
    topicColor:palette.blue500,borderColor:palette.gray200,borderStrong:palette.gray300,divider:palette.gray100,
    lightGray:'#DDDDDD',whiteColor:palette.white,linkColor:'#0088FF',success:palette.green600,
    danger:palette.red500,dangerStrong:palette.red600,
    metric:{
      request:'#4F46E5',requestSoft:'#EEF2FF',requestBorder:'#C7D2FE',
      response:'#0F766E',
      exposure:'#C2410C',exposureSoft:'#FFF7ED',exposureBorder:'#FED7AA',
      click:'#EA580C',cost:'#DC2626',
      revenue:'#047857',revenueSoft:'#ECFDF5',revenueBorder:'#A7F3D0',
      ecpm:'#7C3AED',rate:'#D97706',
    },
  },
  font: {
    family:"'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
    size:fontSizes,
    weight:{regular:400,medium:500,semibold:600,bold:700,extraBold:800},
  },
  space:{1:'4px',2:'8px',3:'12px',4:'16px',5:'20px',6:'24px'},
  radius:{small:'5px',medium:'7px',large:'10px',pill:'999px'},
  shadow:{focus:'0 0 0 3px rgba(59,130,246,.1)',menu:'0 10px 28px rgba(31,41,55,.12)',card:'0 5px 18px rgba(31,41,55,.045)'},
};
